import { CloseButton, Group, Table, Tooltip } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useOrganisation } from '../../../hooks/useOrganisation';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { formatToDateString } from '../../../util/formatting';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { CustomerDto } from '../types/CustomerDto';
import { KeyedRow } from '../../../components/KeyedRow';

export function CustomerRow({ customer }: { customer: CustomerDto }) {
	const navigate = useNavigate();
	const organisation = useOrganisation();

	return (
		<>
			<KeyedRow key={customer.id}>
				<Table.Td>{undefinedCheck(customer.firstName)}</Table.Td>
				<Table.Td>{undefinedCheck(customer.lastName)}</Table.Td>
				<Table.Td>{undefinedCheck(customer.cardNo)}</Table.Td>
				<Table.Td>{undefinedCheck(customer.phone)}</Table.Td>
				<Tooltip w={'10vw'} label={undefinedCheck(customer.email)}>
					<Table.Td w={'10vw'}>{undefinedCheck(customer.email)}</Table.Td>
				</Tooltip>
				<Table.Td>{undefinedCheck(customer.branch)}</Table.Td>
				<Table.Td>{customer.totalPurchases}</Table.Td>
				<Table.Td>
					{customer.joinDate ? (
						formatToDateString(customer.joinDate)
					) : (
						<i>Undefined</i>
					)}
				</Table.Td>
				<Table.Td>
					{customer.endDate ? (
						formatToDateString(customer.endDate)
					) : (
						<i>Undefined</i>
					)}
				</Table.Td>

				<Table.Td>
					<Group align={'center'}>
						<CloseButton
							icon={<IconArrowRight {...defaultIconStyle} />}
							onClick={() =>
								navigate(`/${organisation.get()}/customer/${customer.id}`)
							}
						/>
					</Group>
				</Table.Td>
			</KeyedRow>
		</>
	);
}
